'use client';

import { createContext, useContext, useMemo } from 'react';

import type { SMIDProviderProps } from './use-smid.types';

const SMIDContext = createContext<string | null>(null);

export const useSMID = () => useContext(SMIDContext);

export function SMIDProvider({ children, smid }: SMIDProviderProps) {
  const value = useMemo(() => smid, [smid]);

  return <SMIDContext.Provider value={value}>{children}</SMIDContext.Provider>;
}
